import React from 'react'

import Avatar from 'components/ui/Avatar/Avatar'


const CurrentUserAvatar = ({ className, gender, circle, src, alt }) => (
  <Avatar {...{ className, gender, circle, src, alt }} />
)


export default CurrentUserAvatar
